



import React, { useState, useEffect } from 'react';
import clsx from "clsx";
import PropTypes from 'prop-types';
import {

  // Typography,
  makeStyles,
  // CardContent,
  // Grid,
  TextField,
} from '@material-ui/core';


import {
  Card, CardContent,
  Grid, Typography
} from '@mui/material';

import {
  MAX_LENGTH
} from "common/constants";


import CountUp from 'react-countup';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import numeral from 'numeral';

import firebase from '../../Firebase';
import { getDatabase, ref, onValue, get, child } from 'firebase/database';




const LCStatus = props => {
  const { className, ...rest } = props;
  const classes = useStyles();


  const [totalChargeAmount, setTotalChargeAmount] = useState();
  const [diffAmount, setDiffAmount] = useState();

  const [cumulativeAmount, setCumulativeAmount] = useState(0);
  const [diffCumulative, setDiffCumulative] = useState(0);


  const [predictiveAmount, setPredictiveAmount] = useState();
  const [diffPredictive, setDiffPredictive] = useState();

        // cumulative_amount


      // diff_cumulative

      // predictive_amount: parseFloat(chgr_amount_charging_hour * amount_kwh),
      // diff_predictive: parseFloat(chgr_amount_charging_hour * amount_kwh) - prev_predictive


  const database = getDatabase();
  const dbRef = ref(database);




  const eachLCStatus = (label, cur_val, diff_value) => {

    return (

      <Card raised={false} variant="outlined">
        <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
          <Grid container direction="row">

            <Grid container direction="column" alignItems="center" justifyContent="center" spacing={0}>
              <Typography className={classes.title} color="text.secondary" gutterBottom variant="body1">
                {label}
              </Typography>
            </Grid>


            <Grid container direction="row" alignItems="baseline" justifyContent="center" spacing={0}>

              <Typography variant="h6" >
                <CountUp end={cur_val} duration={0.5} separator="," decimals={1} />
              </Typography>

              <div className={classes.difference}
                style={{
                  justifyContent: 'flex-end',
                  verticalAlign: 'top', paddingTop: "0px"
                  , paddingLeft: "4px"
                }}>
                <Typography className={classes.differenceValue} variant="caption">
                  {diff_value == 0 ? (<span className={classes.grey}><strong>-</strong></span>) :
                    (diff_value > 0 ? (<span className={classes.green}><strong>▲</strong>{diff_value}</span>)
                      : (<span className={classes.red}><strong>▼</strong>{diff_value}</span>))}
                </Typography>
              </div>

            </Grid>
          </Grid>
        </CardContent>
      </Card>
    )
  }


  const makeSampleData = () => {

    onValue(child(dbRef, 'simu/summary/lc'), (snapshot) => {
      setTotalChargeAmount(snapshot.val().total_charge_amount);
      setDiffAmount( snapshot.val().diff_amount );

      setCumulativeAmount( snapshot.val().cumulative_amount );
      setDiffCumulative(numeral(snapshot.val().diff_cumulative).format('0'));

      console.log("snapshot.val().cumulative_amount: "+ snapshot.val().cumulative_amount);

      setPredictiveAmount( snapshot.val().predictive_amount );
      setDiffPredictive(numeral(snapshot.val().diff_predictive).format('0'));
    });
  }


  useEffect(() => {
    makeSampleData();
  }, []);




  return (
    <div>
      <Grid container
        lg={12} md={12} xs={12}
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="space-around"
      >

        <Grid item lg={2} md={2} xs={4}>
          <div style={{ textAlign: "center" }}>LC aggr. <Typography variant="caption" >[kWh]</Typography></div>
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {eachLCStatus('Power Supply', totalChargeAmount, diffAmount)}
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {eachLCStatus('Cum. charge', cumulativeAmount, diffCumulative)}
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {eachLCStatus('Pred. charge', predictiveAmount, diffPredictive)}
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {eachLCStatus('BAT CAP', 1234.5, -1)}
        </Grid>

        <Grid item lg={2} md={2} xs={4}>
          {/* {eachLCStatus('-', '', '')} */}
        </Grid>
      </Grid>
    </div>
  )
}


export default LCStatus;



const useStyles = makeStyles((theme) => ({

  root: {
  },


  chartContainer: {
    // //360px 이상
    // ['@media (min-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 160,
    // },
    // //360px 이하
    // ['@media (max-height:360px)']: {// eslint-disable-line no-useless-computed-key
    //   height: 120,
    // },
    position: 'relative'
  },



  title: {
    fontWeight: 500,
    // paddingLeft: -10,
    // paddingRight: -10,
    marginLeft: -10,
    marginRight: -10,
    // marginBottom: theme.spacing(3),
  },
  differenceValue: {
    // marginRight: theme.spacing(1),
  },
  difference: {
    // marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  // label: {
  //   marginLeft: theme.spacing(1),
  // },
  // labelbox: {
  //   margin: theme.spacing(2),
  // },
  // current: {
  //   marginTop: theme.spacing(0.5),
  //   marginRight: theme.spacing(0.5),
  //   // color: theme.palette.secondary.contrastText,
  //   // backgroundColor: theme.palette.secondary.main,
  // },

  grey: {
    // color: theme.palette.grey.light,
    color: 'lightgrey',
    fontWeight: 600,
  },

  green: {
    color: theme.palette.success.light,
    fontWeight: 600,
  },

  red: {
    color: theme.palette.error.light,
    // color: colors.red[400],
    fontWeight: 600,
  }
}));
